// =============================================
// ErrorBoundary.jsx - 렌더링 에러 차단 컴포넌트
// =============================================
// React에서 자식 컴포넌트가 렌더링 중 에러를 던지면
// 이 컴포넌트가 대신 "에러 화면"을 보여줘.
// → 빨간 에러 창 대신 친절한 메시지 표시!
//
// 사용 예시:
//   <ErrorBoundary fallback={<div>차트 로딩 실패</div>}>
//     <TradingViewWidget ... />
//   </ErrorBoundary>
//
// 주의: ErrorBoundary는 반드시 클래스 컴포넌트로 만들어야 해.
//       React가 에러 포착을 위해 클래스 방식만 지원해.
// =============================================

import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,    // 에러 발생 여부
      errorMsg: '',       // 에러 메시지 (디버그용)
    };
  }

  // 자식 컴포넌트에서 에러가 발생하면 React가 이 메서드를 호출해
  static getDerivedStateFromError(error) {
    return { hasError: true, errorMsg: error?.message || '알 수 없는 에러' };
  }

  // 에러 로그 (개발자 콘솔에 출력)
  componentDidCatch(error, info) {
    console.warn('[ErrorBoundary] 에러 포착:', error?.message, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      // fallback prop이 있으면 그것을, 없으면 기본 에러 메시지
      return this.props.fallback || (
        <div style={{
          height: `${this.props.height || 200}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: '0.75rem',
          backgroundColor: '#1a202c',
          borderRadius: '8px',
          color: '#718096',
          fontSize: '0.9rem',
        }}>
          <span style={{ fontSize: '1.5rem' }}>📊</span>
          <span>차트를 불러오지 못했어</span>
          <button
            onClick={() => this.setState({ hasError: false })}
            style={{
              padding: '0.4rem 1rem',
              backgroundColor: '#2d3748',
              color: '#a0aec0',
              border: '1px solid #4a5568',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '0.82rem',
            }}
          >
            다시 시도
          </button>
        </div>
      );
    }

    // 에러가 없으면 자식 컴포넌트 그대로 렌더링
    return this.props.children;
  }
}

export default ErrorBoundary;
